const Text = {
  variants: {
    'light-green-gradient': {
      bgGradient: 'linear(to-r, #72C215, #BDF878)',
      bgClip: 'text',
    },
  },
};

export default Text;
